import { forwardRef } from "react";
import { Form } from "ui";
import FormRef from "../types/FormRef";

export type AlexSushiInvoiceModel = {};

type AlexSushiInvoiceFormProps = {
    data?: AlexSushiInvoiceModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: AlexSushiInvoiceModel) => void;
};

const AlexSushiInvoiceForm = forwardRef<FormRef, AlexSushiInvoiceFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data ?? {}}
                errors={errors}
                fields={{}}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                Nothing to configure
            </Form>
        );
    },
);

export default AlexSushiInvoiceForm;
